<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>登录密码</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-form ref="taskForm">
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input
            v-model="password"
            autocomplete="off"
            show-password
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col style="text-align:left;margin-left: 4%;color:red;" :span="24">
          查看绩效需要二次验证，请输入密码！请不要将密码告知其他人！
        </el-col>
      </el-row>
      <el-row class="mar_top_20">
        <el-button type="primary" @click="savePwd">登录</el-button>
      </el-row>
      <!-- <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="savePwd">登录</el-button>
            </span> -->
    </el-card>
  </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { UserLogin } from "../../until/ZeusApiSDK/Logic/SalaryInfoLogic";
export default {
  data() {
    return {
      currentUser: {}, //当前用户
      password: "",
      formLabelWidth: "120px"
    };
  },
  //亚敏进入加载方法
  created() {
    //获取当前用户
    this.getCurrentUser();
  },
  methods: {
    //获取当前用户
    getCurrentUser: function() {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //方法区域
    savePwd: function() {
      UserLogin(this.currentUser.UserCode, this.password).then(res => {
         console.log(res);
        if (res.Code == 1) {
          // var msg= this.$message({
          //   showClose: true,
          //   message: "登陆成功",
          //   type: "success"
          // });
          // msg.close();
          
            this.$router.push('/salaryinfo/SalaryAudit');
        } else {
          this.$message({
            showClose: true,
            message: "登陆失败",
            type: "error"
          });
        }
      });
    }
  }
};
</script>